import React from 'react';

function VillageHero({ villageName, blockName, districtName }) {
  return (
    <div className="village-hero">
      <div className="village-hero-content">
        <h1 className="village-hero-title">{villageName}</h1>
        <div className="village-hero-meta">
          {blockName && <span>ब्लॉक: {blockName}</span>}
          {districtName && <span>जिला: {districtName}</span>}
          <span>{new Date().toLocaleDateString('hi-IN')}</span>
        </div>
      </div>
    </div>
  );
}

export default VillageHero;
